import React from 'react';
import { motion } from 'framer-motion';
const mediaItems = [{
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/65n91ixWryu3Z8RDtLRQfM/WhatsApp_Image_2026-04-30_at_1.25.09_PM_(8).jpg'
}, {
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/aJSSZrzNK9VTxq8iDGNiNY/WhatsApp Video 2026-04-30 at 1.25.20 PM.mp4'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/r97kp2TXJa5n1DwrtybhsK/WhatsApp_Image_2026-04-30_at_1.25.09_PM_(4).jpg'
}, {
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/vYbfk5oEgoH1JDWDNjzNKF/WhatsApp Video 2026-04-30 at 1.25.17 PM.mp4'
}, {
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/fkFwt8URKsGQPrJnFxytwT/WhatsApp Video 2026-04-30 at 1.25.16 PM.mp4'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/i3WBunERLVxYpTofRFCZmX/WhatsApp_Image_2026-04-30_at_1.25.09_PM_(1).jpg'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/4CDikCgA7QsLdN62PoNVUV/WhatsApp_Image_2026-04-30_at_1.25.09_PM.jpg'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/myxV9iqU8Wkakus2oBGEb9/WhatsApp_Image_2026-05-01_at_8.10.49_AM_(4).jpg'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/jhFzQeuKxzMebqGFUiFXji/WhatsApp_Image_2026-05-01_at_8.10.49_AM_(3).jpg'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/vbaT635jAnhi3kwDgFGvzn/WhatsApp_Image_2026-05-01_at_8.10.49_AM_(2).jpg'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/rR4CspHwzYj22H4TBt2qPW/WhatsApp_Image_2026-05-01_at_8.10.49_AM_(1).jpg'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/oZn828ho3TTWjHANxtY4Hq/WhatsApp_Image_2026-05-01_at_8.10.49_AM.jpg'
}];
const row1 = mediaItems;
const row2 = [...mediaItems].reverse();
const MediaItem = ({
  item
}: {
  item: {
    type: string;
    src: string;
  };
}) => {
  if (item.type === 'video') {
    return <video src={item.src} className="w-full h-full object-cover" autoPlay loop muted playsInline data-id="element-215" />;
  }
  return <img src={item.src} alt="Gallery" className="w-full h-full object-cover" data-id="element-216" />;
};
export function PhotoGallery() {
  return <section className="py-16 bg-cream overflow-hidden" data-id="element-217">
      <div className="flex flex-col gap-6" data-id="element-218">
        {/* Row 1 - Scrolling Left */}
        <div className="relative w-full flex overflow-hidden" data-id="element-219">
          <motion.div className="flex gap-6 whitespace-nowrap" animate={{
          x: ['0%', '-50%']
        }} transition={{
          repeat: Infinity,
          ease: 'linear',
          duration: 40
        }} data-id="element-220">
            {[...row1, ...row1].map((item, idx) => <div key={`row1-${idx}`} className="w-64 h-64 md:w-80 md:h-80 flex-shrink-0 rounded-lg overflow-hidden shadow-md" data-id="element-221">
                <MediaItem item={item} data-id="element-222" />
              </div>)}
          </motion.div>
        </div>

        {/* Row 2 - Scrolling Right */}
        <div className="relative w-full flex overflow-hidden" data-id="element-223">
          <motion.div className="flex gap-6 whitespace-nowrap" animate={{
          x: ['-50%', '0%']
        }} transition={{
          repeat: Infinity,
          ease: 'linear',
          duration: 40
        }} data-id="element-224">
            {[...row2, ...row2].map((item, idx) => <div key={`row2-${idx}`} className="w-64 h-64 md:w-80 md:h-80 flex-shrink-0 rounded-lg overflow-hidden shadow-md" data-id="element-225">
                <MediaItem item={item} data-id="element-226" />
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}